import { type Configuration, PublicClientApplication, LogLevel } from "@azure/msal-browser"

const getRedirectUrl = (): string => {
  if (typeof window == "undefined") {
    return ''
  }
  const origin = window.location.origin
  if (origin.indexOf('localhost') > 0) {
    return 'http://localhost:5173/';
  } else if (origin.indexOf('biogain-dev-app') > 0) {
    return 'https://biogain-dev-app.azureedge.net'
  } else if (origin.indexOf('biogain-prod-app') > 0) {
    return 'https://biogain-prod-app.azureedge.net'
  } else if (origin.indexOf('dev.app.biogain.ai') > 0) {
    return 'https://dev.app.biogain.ai'
  } else if (origin.indexOf('app.biogain.ai') > 0) {
    return 'https://app.biogain.ai'
  }

  throw new Error(`no redirect found for ${origin}`)
}

const getClientId = (): string => {
  if (typeof window == "undefined") {
    return ''
  }
  const origin = window.location.origin
  if (origin.indexOf('localhost') > 0) {
    return 'a963316a-ab4b-44fe-ac5e-1dfb42e93858';
  } else if (origin.indexOf('biogain-dev-app') > 0 || origin.indexOf('dev.app.biogain.ai') > 0) {
    return 'a963316a-ab4b-44fe-ac5e-1dfb42e93858'
  } else if (origin.indexOf('biogain-prod-app') > 0 || origin.indexOf('app.biogain.ai') > 0) {
    return '85a00520-51b3-452e-b34d-490c1184d672'
  }
  throw new Error(`no client id found for ${origin}`)
}

const getAuthorityId = (): string => {
  if (typeof window == "undefined") {
    return ''
  }
  const origin = window.location.origin
  if (origin.indexOf('localhost') > 0) {
    return 'https://btdevtenant.ciamlogin.com/b7aced01-8739-46a5-ba8e-5f36e2300f42/';
  } else if (origin.indexOf('biogain-dev-app') > 0 || origin.indexOf('dev.app.biogain.ai') > 0) {
    return 'https://btdevtenant.ciamlogin.com/b7aced01-8739-46a5-ba8e-5f36e2300f42/'
  } else if (origin.indexOf('biogain-prod-app') > 0 || origin.indexOf('app.biogain.ai') > 0) {
    return 'https://btprodtenant.ciamlogin.com/d792737c-d542-451c-8c04-20afcd604ccf/'
  }
  throw new Error(`no authority found for ${origin}`)
}

const getScopes = (): string => {
  if (typeof window == "undefined") {
    return ''
  }
  const origin = window.location.origin
  if (origin.indexOf('localhost') > 0) {
    return 'https://btdevtenant.onmicrosoft.com/bgapi/Data.Read';
  } else if (origin.indexOf('biogain-dev-app') > 0 || origin.indexOf('dev.app.biogain.ai') > 0) {
    return 'https://btdevtenant.onmicrosoft.com/bgapi/Data.Read'
  } else if (origin.indexOf('biogain-prod-app') > 0 || origin.indexOf('app.biogain.ai') > 0) {
    return 'https://btprodtenant.onmicrosoft.com/bgapi/Data.Read'
  }
  throw new Error(`no authority found for ${origin}`)
}

// MSAL configuration
export const msalConfig: Configuration = {
  auth: {
    clientId: getClientId(),
    authority: getAuthorityId(),
    redirectUri: getRedirectUrl(),
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message)
            return
          case LogLevel.Info:
            console.info(message)
            return
          case LogLevel.Verbose:
            console.debug(message)
            return
          case LogLevel.Warning:
            console.warn(message)
            return
        }
      },
    },
  },
}

// Create the main myMSALObj instance
export const msalInstance = new PublicClientApplication(msalConfig)

// Initialize MSAL
export const initializeMsal = async () => {
  await msalInstance.initialize()
}

export const scopes: string[] = [getScopes(), "openid","offline_access"]

// Login request configuration
export const loginRequest = {
  scopes: scopes,
  redirectUri: "/",
}